import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
@Component({
  selector: 'app-order-name-cell-render',
  templateUrl: './order-name-cell-render.component.html',
})
export class OrderNameCellRenderComponent implements ICellRendererAngularComp {
  cellvalue: string;
  link: string;
  refresh(params): boolean {
    this.initializeValues(params);
    return true;
  }
  agInit(params): void {
    this.initializeValues(params);
  }

  initializeValues(params) {
    this.cellvalue = params?.data?.orderNumber;
    this.link = `${params?.actionBaseLink}/${params?.data?.orderNumber}`;
  }
}
